import './CreateCombinatorialPlaylist.css';
import React, {useEffect, useState} from "react";
import {Playlist} from "./Playlist";
import {ConfirmationButton} from '../../../common/Buttons';
import {ErrorMessage} from "../../../common/ErrorMessage";
import {ErrorCode} from "../../../../api/ApiError";
import {Link} from "react-router-dom";
import {WizardsContainer} from "./wizard/WizardsContainer";
import {CombinatorialPreference} from "./CombinatorialPreference";
import Progress from "../../progress/Progress";

interface CreateCombinatorialPlaylistProps {
    currentCombinatorialPreferences: CombinatorialPreference[];
    availableDecadePlaylists: Playlist[];
    availableGenrePlaylists: Playlist[];
    availableNationalityPlaylists: Playlist[];
    availableMoodPlaylists: Playlist[];
    numberOfCombinatorialPlaylists: number;
    updateWizardInProgress: (inProgress: boolean) => void;
    wizardInProgress: boolean;
    userHasAccessToCombinatorialPlaylists: boolean;
}

export const MaximumNumberOfCombinatorialPlaylists: number = 20;

const CreateCombinatorialPlaylist = (props: CreateCombinatorialPlaylistProps) => {
    let preferenceCreationElement = props.numberOfCombinatorialPlaylists >= MaximumNumberOfCombinatorialPlaylists
        ? <NoMoreRoomForPreferences/>
        : props.wizardInProgress
            ? <WizardsContainer
                availableNationalityPlaylists={props.availableNationalityPlaylists}
                availableGenrePlaylists={props.availableGenrePlaylists}
                availableDecadePlaylists={props.availableDecadePlaylists}
                availableMoodPlaylists={props.availableMoodPlaylists}
                goToOverview={() => props.updateWizardInProgress(false)}
                numberOfCombinatorialPlaylists={props.numberOfCombinatorialPlaylists}/>
            : <NewCombinationStartingPoint userHasAccessToCombinatorialPlaylists={props.userHasAccessToCombinatorialPlaylists}
                                           startWizard={() => props.updateWizardInProgress(true)}/>;
    return (
        <div className="pageContentSegment">
            <h2>Combination playlists</h2>
            {preferenceCreationElement}
        </div>
    )
}

interface NewCombinationStartingPointProps {
    startWizard: Function;
    userHasAccessToCombinatorialPlaylists: boolean;
}

const NewCombinationStartingPoint = (props: NewCombinationStartingPointProps) => {
    const [errorCode, setErrorCode] = useState<ErrorCode>();

    function start() {
        setErrorCode(undefined);
        if (!props.userHasAccessToCombinatorialPlaylists) {
            setErrorCode(ErrorCode.FeatureNotAvailableForCurrentMembershipLevel);
            return;
        }
        props.startWizard();
    }

    return (
        <div>
            <>
                <p>Combination playlists allow you to combine genres, decades, moods, and nationalities to make a playlist that fits your exact needs, for example:</p>
                <ul>
                    <li>a playlist of all of your rock and pop songs.</li>
                    <li>a playlist of all of your rock songs from from the 1950s to the 1990s.</li>
                    <li>a playlist of all your British folk songs.</li>
                </ul>
            </>
            {!props.userHasAccessToCombinatorialPlaylists &&
                <p className="premiumText">
                    <Link to={'/plans'}>Upgrade to premium ⭐ </Link> to get access to combination playlists and more.
                </p>
            }
            <div className="combinationPlaylistStartButton">
                <ConfirmationButton
                    onClick={() => start()}
                    text={"Let's go!"}
                    marginTop={true}
                    marginBottom={true}/>
                <ErrorMessage errorCode={errorCode}/>
            </div>
        </div>
    )
}

const NoMoreRoomForPreferences = () => {
    return (
        <div>
            You have no more room for additional combination playlists. Delete one to be able to create a new one.
        </div>
    )
}


export default CreateCombinatorialPlaylist;
